import React from "react";
import { Icons } from "contents/icons";
import { Icon } from "components/icon/Icon";
import { StyledDialogCaption } from "./style";
import { useDialogOverlayContext } from "components/dialog/controller/DialogOverlay";

interface DialogCaptionProps {
  icon?: keyof typeof Icons;
  children: React.ReactNode;
}

export const DialogCaption = ({ icon, children }: DialogCaptionProps) => {
  const { $size, $state } = useDialogOverlayContext();
  return (
    <StyledDialogCaption $size={$size} $state={$state}>
      {icon && (
        <Icon className="icon" icon={icon} size={12} stroke="--text-gray-4" />
      )}
      <p>{children}</p>
    </StyledDialogCaption>
  );
};
